import { AustralianState, CampaignDetailModelState } from '@urbanx/agx.campaigns.client';
import { useAppSelector } from './useAppSelector';
import { AppFeatures } from '@urbanx/agx.agencies.client';

export const useFeatureToggles = (
  state?: AustralianState | CampaignDetailModelState
): AppFeatures & { isLoading: boolean } => {
  const { featureToggles } = useAppSelector((state) => state.agentInfo);
  const firstAgencyState = useAppSelector(
    (state) => state.agencies.agencyInfo.info.agencyStates?.[0]
  );
  const featureToggleState = state ?? firstAgencyState;

  if (!featureToggles || !featureToggleState) return { isLoading: true };

  return { ...featureToggles[featureToggleState], isLoading: false };
};
